(ns quuppa.qsm.site.events
  (:require [quuppa.frontend-utils :as utils]
            [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.projects.events :as project-e]
            [quuppa.qsm.ui-state.events :as ui-state]))

(def project-sites-query (q/create-query :qsm/list-sites [:project-id]))

(rf/reg-event-fx :site/get-project-sites
  (fn [_ [_ project-id]]
    {:fx [[::q/execute [project-sites-query {:project-id project-id}]]]}))

(rf/reg-event-fx ::get-qpe-data
  (fn [_ [_ site-id]]
    {:fx [[:dispatch [:init/state-all {:site-id site-id}]]]}))

(rf/reg-event-db :qsm/site-add
  (q/update-event-fn project-sites-query conj))

(rf/reg-event-db :qsm/site-update
  (q/update-event-fn project-sites-query (fn [result site]
                                           ;; Replace matching site in a vector
                                           (into (empty result)
                                                 (map (fn [v]
                                                        (if (= (:id v) (:id site))
                                                          site
                                                          v))
                                                      result)))))

(rf/reg-event-db :qsm/site-remove
  (q/update-event-fn project-sites-query (fn [result {:keys [id]}]
                                           ;; Remove matching site from the vector
                                           (into (empty result) (remove #(= id (:id %)) result)))))
;;
;; New site
;;

(rf/reg-event-fx ::init-new-site-form
  (fn [{:keys [db]} [_ page-key project-id]]
    {:db (-> db
             (assoc :site-form {:data {:name       ""
                                       :project-id project-id}})
             ;; Ensure both forms aren't open
             (dissoc :project-form))
     :fx [[:dispatch [::ui-state/set-sidebar-type page-key :new-site-form]]]}))

(rf/reg-event-fx ::save-new-site
  (fn [{:keys [db]} _]
    {:fx [[:server-dispatch {:event [:qsm/create-site (-> db :site-form :data)]
                             :on-success [::save-site-success false]
                             :on-error [::save-site-error "Create site failed"]}]]}))

;;
;; Edit site
;;

(rf/reg-event-db ::init-edit-site-form
  (fn [db [_ site]]
    (assoc db :site-form {:id         (:id site)
                          :original-project-id (:project-id site)
                          :spatiable-enabled (:spatiable-enabled site)
                          ;; :data should only contains properties that are sent to the backend
                          ;; TODO: Location field is deprecated, not editable. For some reason
                          ;; it is still included in list data.
                          :data (select-keys site [:name :project-id :resource-role :positional-data-history-enabled])})))

(rf/reg-event-fx ::save-site
  (fn [{:keys [db]} _]
    (let [get-data          (fn [& path-keys] (get-in db (apply conj [:site-form :data] path-keys)))
          source-project-id (get-in db [:site-form :original-project-id])
          target-project-id (get-data :project-id)
          projects          (:result (q/get-result db project-e/projects-query {}))
          target-project    (first (filter #(= target-project-id (:id %)) projects))]
      (if (not= source-project-id target-project-id)
        {:fx [[:dispatch [:confirm/open {:title        "Move site?"
                                         :message      [:span [:strong (get-data :name)]
                                                        " site will be moved to "
                                                        [:strong (:name target-project)]
                                                        " project."]
                                         :ok-label     "Move"
                                         :ok-class     "btn btn-danger"
                                         :cancel-class "btn btn-outline-secondary"
                                         :on-confirm   [::save-site-confirmed true]}]]]}
        {:fx [[:dispatch [::save-site-confirmed false]]]}))))

(rf/reg-event-fx ::moved-site-and-saved
  (fn [{:keys [db]}]
    {:fx [[:server-dispatch {:event [:qsm/save-site (assoc (-> db :site-form :data)
                                                           :site-id (-> db :site-form :id))]
                             :on-success [:push-state [:projects]]
                             :on-error [::save-site-error "Save site failed"]}]]}))

(rf/reg-event-fx ::save-site-confirmed
  (fn [{:keys [db]} [_ moved-site?]]
    {:fx [[:server-dispatch {:event [:qsm/save-site (assoc (-> db :site-form :data)
                                                           :site-id (-> db :site-form :id))]
                             :on-success [::save-site-success moved-site?]
                             :on-error [::save-site-error "Save site failed"]}]]}))

;;
;; New and update site
;;

(rf/reg-event-db ::site-form-set-value
  (fn [db [_ k v]]
    (assoc-in db [:site-form :data k] v)))


(rf/reg-event-db ::cancel-site-form
  (fn [db _]
    (dissoc db :site-form)))

(rf/reg-event-fx ::init-create-qpe-group
  (fn [{:keys [db]} [_ data]]
    {:db (-> db
             (assoc :qpe-group-form {:data data}))
     :fx [[:dispatch [::ui-state/set-sidebar-type :project :new-qpe-group-form]]]}))

(rf/reg-event-fx ::init-edit-qpe-group
  (fn [{:keys [db]} [_ data]]
    {:db (-> db
             (assoc :edit-qpe-group-form {:data data}))
     :fx [[:dispatch [::ui-state/set-sidebar-type :project :edit-qpe-group-form]]]}))

(rf/reg-event-db ::cancel-qpe-group-form
  (fn [db _]
    (dissoc db :qpe-group-form)))

(rf/reg-event-fx ::delete-qpe-group-success
  (fn [{:keys [db]} [_ qpe-group-id]]
    {:db (if (empty? (:qpe-groups db))
           (dissoc db :qpe-groups)
           (assoc db :qpe-groups (->> db
                                      :qpe-groups
                                      (remove (fn [group]
                                                (= (:id group) qpe-group-id)))
                                      (vec))))
     :fx [[:dispatch [::cancel-edit-qpe-group-form]]
          [:remove-from-local-storage {:local-storage-key "qpe-groups"
                                       :value qpe-group-id}]]}))

(rf/reg-event-db ::cancel-edit-qpe-group-form
  (fn [db _]
    (dissoc db :edit-qpe-group-form)))

(rf/reg-event-db ::qpe-group-form-set-value
  (fn [db [_ k v]]
    (assoc-in db [:qpe-group-form :data k] v)))

(rf/reg-event-db ::edit-qpe-group-form-set-value
  (fn [db [_ k v]]
    (assoc-in db [:edit-qpe-group-form :data k] v)))

(defn upsert-by-id [coll new-item]
  (let [id (:id new-item)]
    (if (some #(= (:id %) id) coll)
      (mapv (fn [item]
              (if (= (:id item) id)
                new-item
                item))
            coll)
      (conj coll new-item))))

(rf/reg-fx
  :remove-from-local-storage
  (fn [{:keys [local-storage-key value]}]
    (let [existing (utils/get-item! local-storage-key)
          current (if (sequential? existing)
                    (vec existing)
                    [])
          updated (vec (remove #(= (:id %) value) current))]
      (if (empty? updated)
        (utils/remove-item! local-storage-key)
        (utils/set-item! local-storage-key updated)))))

(rf/reg-event-fx :qsm/qpe-groups
  (fn [{:keys [db]} [_ qpe-group]]
    {:db (assoc db :qpe-groups (upsert-by-id (:qpe-groups db) qpe-group))
     :fx [[:update-local-storage {:local-storage-key "qpe-groups"
                                  :value qpe-group}]]}))

(rf/reg-event-fx ::create-qpe-group
  (fn [{:keys [db]} [_ _]]
    {:fx [[:server-dispatch {:event [:qsm/create-qpe-group (-> db :qpe-group-form :data)]
                             :on-success [::create-qpe-group-success false]
                             :on-error [::create-qpe-group-error "Create site failed"]}]]}))

(rf/reg-event-db ::select-engine-tab
  (fn [db [_ selected-tab]]
    (assoc-in db [:ui-state :selected-engine-tab] selected-tab)))

(rf/reg-event-db ::create-qpe-group-success
  (fn [db [_ _]]
    (dissoc db :qpe-group-form)))

(rf/reg-event-fx ::create-qpe-group-error
  (fn [{:keys [db]} [_ message error]]
    {:db (assoc-in db [:qpe-group-form :error] {:message message
                                                :data error})}))

(rf/reg-event-fx ::get-active-siteplan-key
  (fn [_ [_ siteplan-id]]
    {:fx [[:server-dispatch {:event [:site/active-site-plan {:site-id siteplan-id}]
                             :on-success [::get-qpe-groups]
                             :on-error [:notifications/notify
                                        {:type       :error
                                         :heading    "Failed to get active siteplan key"
                                         :message    (str "Failed to get active siteplan key: " siteplan-id)}]}]]}))

(rf/reg-event-fx ::get-qpe-groups
  (fn [_ [_ active-siteplan]]
    {:fx [[:server-dispatch {:event [:qsm/list-qpe-groups]
                             :on-success [::get-qpe-groups-from-local-storage (if (string? (:key active-siteplan))
                                                                                (uuid (:key active-siteplan))
                                                                                (:key active-siteplan))]
                             :on-error [:notifications/notify
                                        {:type       :error
                                         :heading    "Failed to get engine groups"
                                         :message    (str "Failed to get engine groups for siteplan: " (:key active-siteplan))}]}]]}))

(rf/reg-event-db ::get-qpe-groups-from-local-storage
  (fn [db [_ siteplan-id qpe-groups-from-db]]
    (let [site-qpe-group (->> qpe-groups-from-db
                              (filter (fn [qpe-group]
                                        (= siteplan-id (:siteplan-id qpe-group))))
                              (first))
          local-storage-qpe-groups (utils/get-item! "qpe-groups")
          local-storage-qpe-group-data (->> local-storage-qpe-groups
                                            (filter (fn [qpe-group]
                                                      (= siteplan-id (:siteplan-id qpe-group))))
                                            (first))
          merged-data (merge site-qpe-group local-storage-qpe-group-data)]
      (when (seq merged-data)
        (assoc db :qpe-groups (conj (:qpe-groups db) merged-data))))))

(rf/reg-event-db ::edit-qpe-group-success
  (fn [db [_ _]]
    (dissoc db :edit-qpe-group-form)))

(rf/reg-event-fx ::edit-qpe-group
  (fn [{:keys [db]} [_ data]]
    {:fx [[:server-dispatch {:event [:qsm/edit-qpe-group (-> db :edit-qpe-group-form :data)]
                             :on-success [::edit-qpe-group-success]
                             :on-error [:notifications/notify
                                        {:type       :error
                                         :heading    "Failed to edit qpe group"
                                         :message    (str "Failed to edit qpe group: " (:id data))}]}]]}))

(rf/reg-event-fx ::delete-qpe-group
  (fn [_ [_ qpe-group-id]]
    {:fx [[:server-dispatch {:event [:qsm/delete-qpe-group {:qpe-group-id qpe-group-id}]
                             :on-success [::delete-qpe-group-success qpe-group-id]
                             :on-error [:notifications/notify
                                        {:type       :error
                                         :heading    "Failed to delete qpe group"
                                         :message    (str "Failed to delete qpe group: " qpe-group-id)}]}]]}))

(rf/reg-event-fx ::save-site-success
  (fn [{:keys [db]} [_ moved-site?]]
    {:db (dissoc db :site-form)
     :fx [[:dispatch [:confirm/close]]
          (when moved-site?
            [:push-state [:projects]])]}))

(rf/reg-event-fx ::save-site-error
  (fn [{:keys [db]} [_ message error]]
    {:db (assoc-in db [:site-form :error] {:message message
                                           :data error})}))

(rf/reg-event-fx ::set-qpe-site
  (fn [_ [_ qpe-identity site-id]]
    {:fx [[:server-dispatch {:event [:qsm/set-qpe-site {:identity qpe-identity
                                                        :site-id site-id}]
                             :on-success [:confirm/close]}]]}))

(rf/reg-event-fx ::disconnect-engine
  (fn [_ [_ qpe-identity]]
    {:fx [[:dispatch [:confirm/open {:title "Disconnect the engine from site?"
                                     :message [:span
                                               "The engine will be disconnected from the site."]
                                     :ok-label "Disconnect"
                                     :ok-class "btn btn-danger"
                                     :cancel-class "btn btn-outline-secondary"
                                     :on-confirm [::set-qpe-site qpe-identity nil]}]]]}))

;;
;; Delete site
;;

(rf/reg-event-fx ::delete-site
  (fn [_ [_ site-id site-name]]
    {:fx [[:dispatch [:confirm/open {:title "Delete site?"
                                     :message [:span "You are about to delete "
                                               [:strong site-name]
                                               " site. Are you sure?"]
                                     :ok-label "Delete"
                                     :ok-class "btn btn-danger"
                                     :cancel-class "btn btn-outline-secondary"
                                     :on-confirm [::delete-site-confirmed site-id]}]]]}))

(rf/reg-event-fx ::delete-site-confirmed
  (fn [_ [_ site-id]]
    {:fx [[:server-dispatch {:event [:qsm/delete-site {:site-id site-id}]
                             :on-success [::delete-site-done site-id]
                             :on-error #(js/console.error %)}]]}))

(rf/reg-event-fx ::delete-site-done
  (fn [{:keys [db]} [_ deleted-site-id _result]]
    ;; If we are on deleted site page, redirect to project view list.
    (let [{:keys [site-id project-id]} (-> db :quuppa.routing/match :parameters :path)]
      {:fx [[:dispatch [:confirm/close]]
            (when (and (= :site (-> db :quuppa.routing/match :data :name))
                       (= (str deleted-site-id) site-id))
              [:push-state [:project {:project-id project-id}]])]})))
